import listActions from 'src/modules/sustainability/list/sustainabilityListActions';
import SustainabilityService from 'src/modules/sustainability/sustainabilityService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import Message from 'src/view/shared/message';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'SUSTAINABILITY_DESTROY';

const sustainabilityDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: sustainabilityDestroyActions.DESTROY_STARTED,
      });

      await SustainabilityService.destroyAll([id]);

      dispatch({
        type: sustainabilityDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.sustainability.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      navigateTo('/library/sustainability');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: sustainabilityDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: sustainabilityDestroyActions.DESTROY_ALL_STARTED,
      });

      await SustainabilityService.destroyAll(ids);

      dispatch({
        type: sustainabilityDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(i18n('entities.sustainability.destroyAll.success'));

      navigateTo('/library/sustainability');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: sustainabilityDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default sustainabilityDestroyActions;
